export default __webpack_public_path__ + "static/media/vaults.d6801c72.svg";